import { useSettingsStore } from "@/data/settingsStore";

export type MetricType = 'facebook' | 'twitter' | 'instagram' | 'youtube' | 'website' | 'program' | 'presentation' | 'like';

export interface PartyMetrics {
  acronym: string;
  facebook: number;
  twitter: number;
  instagram: number;
  youtube: number;
  website: number;
  program: number;
  presentation: number;
  like: number;
}

const STORAGE_KEY = "kaynin_party_metrics";

export function getPartyMetrics(): Record<string, PartyMetrics> {
  const data = useSettingsStore.getState().getSetting(STORAGE_KEY, "");
  return data && typeof data === "string" ? JSON.parse(data) : {};
}

export function incrementPartyMetric(partyAcronym: string, metric: MetricType) {
  const metrics = getPartyMetrics();
  if (!metrics[partyAcronym]) {
    metrics[partyAcronym] = {
      acronym: partyAcronym,
      facebook: 0,
      twitter: 0,
      instagram: 0,
      youtube: 0,
      website: 0,
      program: 0,
      presentation: 0,
      like: 0
    };
  }
  metrics[partyAcronym][metric] = (metrics[partyAcronym][metric] || 0) + 1;
  useSettingsStore.getState().updateSetting(STORAGE_KEY, JSON.stringify(metrics)).catch(() => {});
}

export function decrementPartyMetric(partyAcronym: string, metric: MetricType) {
    const metrics = getPartyMetrics();
    if (metrics[partyAcronym] && metrics[partyAcronym][metric] > 0) {
        metrics[partyAcronym][metric]--;
        useSettingsStore.getState().updateSetting(STORAGE_KEY, JSON.stringify(metrics)).catch(() => {});
    }
}
